
/*
===============================================================================
biehistoricalworkbook.apis.ts — canonical workbook operations
===============================================================================
*/

import { generateTrackId, json, postBiz, uploadBiz } from '../core/coreapi';

import {
  BieHistoricalWorkbookUploadRequest,
  BieHistoricalWorkbookUploadResult,
  BieHistoricalWorkbookValidateRequest,
  BieHistoricalWorkbookValidateResult,
} from './biehistoricalworkbook.models';

import {
  normalizeBieHistoricalWorkbookUpload,
  normalizeBieHistoricalWorkbookValidate,
} from './biehistoricalworkbook.normalizers';

const SERVICE = 'biehistoricalworkbook';
const UPLOAD_PREFIX = 'biehis';

export async function uploadBieHistoricalWorkbook(
  request: BieHistoricalWorkbookUploadRequest
): Promise<BieHistoricalWorkbookUploadResult> {
  const response = await uploadBiz({
    service: SERVICE,
    action: 'upload',
    prefix: UPLOAD_PREFIX,
    file: request.file,

    params: {
      tki: request.trackId ?? generateTrackId(),
      pci: request.planningcycleid,
      hdi: request.historicaldatasetid ?? null,
      rex: request.replaceExisting ? 1 : 0,
      rmk: request.remarks || '',
    },
  } as any);

  return normalizeBieHistoricalWorkbookUpload(json(response));
}

export async function resolveValidateBieHistoricalWorkbook(
  request: BieHistoricalWorkbookValidateRequest
): Promise<BieHistoricalWorkbookValidateResult> {
  const response = await postBiz({
    s: SERVICE,
    a: 'validate',

    pci: request.planningcycleid,
    hdi: request.historicaldatasetid ?? null,
    chk: request.checksum ?? null,
  });

  return normalizeBieHistoricalWorkbookValidate(json(response));
}

